module.exports = __webpack_public_path__ + "img/agreement-bbb-seal.37d36129.png";